module.exports = __webpack_public_path__ + "static/img/oil7.a8f5b1bc.png";